function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// src/components/alert.ts
import { alertAnatomy as parts } from "@chakra-ui/anatomy";
import { createMultiStyleConfigHelpers, cssVar } from "@chakra-ui/styled-system";
import { transparentize } from "@chakra-ui/theme-tools";
var _createMultiStyleConf = createMultiStyleConfigHelpers(parts.keys),
  definePartsStyle = _createMultiStyleConf.definePartsStyle,
  defineMultiStyleConfig = _createMultiStyleConf.defineMultiStyleConfig;
var $fg = cssVar("alert-fg");
var $bg = cssVar("alert-bg");
var baseStyle = definePartsStyle({
  container: {
    bg: $bg.reference,
    px: "4",
    py: "3"
  },
  title: {
    fontWeight: "bold",
    lineHeight: "6",
    marginEnd: "2"
  },
  description: {
    lineHeight: "6"
  },
  icon: {
    color: $fg.reference,
    flexShrink: 0,
    marginEnd: "3",
    w: "5",
    h: "6"
  },
  spinner: {
    color: $fg.reference,
    flexShrink: 0,
    marginEnd: "3",
    w: "5",
    h: "5"
  }
});
function getBg(props) {
  var theme = props.theme,
    c = props.colorScheme;
  var darkBg = transparentize("".concat(c, ".200"), 0.16)(theme);
  return {
    light: "colors.".concat(c, ".100"),
    dark: darkBg
  };
}
var variantSubtle = definePartsStyle(function (props) {
  var c = props.colorScheme;
  var bg = getBg(props);
  return {
    container: _defineProperty(_defineProperty(_defineProperty({}, $fg.variable, "colors.".concat(c, ".600")), $bg.variable, bg.light), "_dark", _defineProperty(_defineProperty({}, $fg.variable, "colors.".concat(c, ".200")), $bg.variable, bg.dark))
  };
});
var variantLeftAccent = definePartsStyle(function (props) {
  var c = props.colorScheme;
  var bg = getBg(props);
  return {
    container: _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, $fg.variable, "colors.".concat(c, ".600")), $bg.variable, bg.light), "_dark", _defineProperty(_defineProperty({}, $fg.variable, "colors.".concat(c, ".200")), $bg.variable, bg.dark)), "paddingStart", "3"), "borderStartWidth", "4px"), "borderStartColor", $fg.reference)
  };
});
var variantTopAccent = definePartsStyle(function (props) {
  var c = props.colorScheme;
  var bg = getBg(props);
  return {
    container: _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, $fg.variable, "colors.".concat(c, ".600")), $bg.variable, bg.light), "_dark", _defineProperty(_defineProperty({}, $fg.variable, "colors.".concat(c, ".200")), $bg.variable, bg.dark)), "pt", "2"), "borderTopWidth", "4px"), "borderTopColor", $fg.reference)
  };
});
var variantSolid = definePartsStyle(function (props) {
  var c = props.colorScheme;
  return {
    container: _defineProperty(_defineProperty(_defineProperty(_defineProperty({}, $fg.variable, "colors.white"), $bg.variable, "colors.".concat(c, ".600")), "_dark", _defineProperty(_defineProperty({}, $fg.variable, "colors.gray.900"), $bg.variable, "colors.".concat(c, ".200"))), "color", $fg.reference)
  };
});
var variants = {
  subtle: variantSubtle,
  "left-accent": variantLeftAccent,
  "top-accent": variantTopAccent,
  solid: variantSolid
};
var alertTheme = defineMultiStyleConfig({
  baseStyle: baseStyle,
  variants: variants,
  defaultProps: {
    variant: "subtle",
    colorScheme: "blue"
  }
});
export { alertTheme };